module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit active",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("账号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "necessary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "necessary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "necessary"
  }, [_c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  })]), _vm._v(" "), _c('div', {
    staticClass: "read"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "sel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onoff),
      expression: "onoff"
    }],
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": "sel"
    },
    domProps: {
      "checked": Array.isArray(_vm.onoff) ? _vm._i(_vm.onoff, null) > -1 : (_vm.onoff)
    },
    on: {
      "click": _vm.trackAgreement,
      "change": function($event) {
        var $$a = _vm.onoff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onoff = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onoff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onoff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selbox",
    class: _vm.onoff ? 'active' : ''
  }), _vm._v("阅读并同意\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.alertFn.apply(null, arguments)
      }
    }
  }, [_vm._v("《图灵机器人开放平台服务协议》")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    staticStyle: {
      "display": "block",
      "padding-left": "85px",
      "padding-top": "8px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.alertFn1.apply(null, arguments)
      }
    }
  }, [_vm._v("《图灵机器人开放平台隐私权政策》")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("已有账号？")]), _vm._v("登录")])], 1)])]), _vm._v(" "), _c('agreement', {
    attrs: {
      "alertshow": _vm.alertshow
    },
    on: {
      "close": _vm.close,
      "agree": _vm.agree,
      "unagree": _vm.unagree
    }
  }), _vm._v(" "), _c('user-agreement', {
    attrs: {
      "alertshow1": _vm.alertshow1
    },
    on: {
      "close1": _vm.close1,
      "agree1": _vm.agree1,
      "unagree1": _vm.unagree1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c4af08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/register.vue
// module id = 103
// module chunks = 1